import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../Components/Navbar/Navbar";
import Footer from "../Components/Footer/Footer";
import { animateScroll as scroll } from "react-scroll";

const ComingSoon = () => {
  useEffect(() => {
    scroll.scrollToTop({ duration: 500 });
  }, []);
  return (
    <>
      <Helmet>
        <title>Coming Soon | Aneeq Ullah Khan</title>
        <meta name="description" content="Soon The Page Is Coming...." />
        <meta
          name="keywords"
          content="Aneeq, Aneeq Ullah Khan, Aneeq Ullah Khan Portfolio, Aneeq Khan, Aneeq Portfolio, Aneeq Resume, Aneeq CV, Aneeq Firebase, Aneeq Ullah Khan Fiverr, Aneeq Ullah Khan Linkedin, React, React Js, Aneeq Ullah Khan React Developer, Top Pakistan React Developer, Pakistan Developer, Top Pakistan Frontend Developer, Frontend Developer"
        />
      </Helmet>
      <Navbar />

      <div className="container mt-5 mb-5 text-center">
        <br />
        <h1 className="fw-bolder">Coming Soon...</h1>
        <p>Stay Tuned!</p>
        <br />
      </div>

      <Footer />
    </>
  );
};

export default ComingSoon;
